import React, { useState } from 'react';
import axios from 'axios';
import '../custom.css';
import * as AppConstants from '../AppConstants';
import { toast } from 'react-toastify';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import moment from 'moment';

export const Login = () => {
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');

  const handleChangeUsername = (e) => {
    setUsername(e.target.value);
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const signIn = () => {
    axios.defaults.baseURL = AppConstants.BASE_URL;
    const options = {
      method: 'POST',
      url: `/user/LoginWithSettings`,
      headers: {
        accept: 'application/json',
        ApiKey: AppConstants.API_KEY,
        'Content-Type': 'application/json',
      },
      data: { username: username, password: password },
    };
    setIsLoading(true);
    const uninterceptedAxiosInstance = axios.create();
    uninterceptedAxiosInstance
      .request(options)
      .then((response) => {
        axios.defaults.headers.common = {
          ApiKey: AppConstants.API_KEY,
          Authorization: `Bearer ${response.data.accessToken}`,
          accepts: 'application/json',
        };
        localStorage.setItem('token', response.data.accessToken);
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('username', response.data.username);
        localStorage.setItem('staffMemberId', response.data.staffMemberInfo.id);
        localStorage.setItem('lastInteraction', moment());
        
        localStorage.setItem(
          'geoRegionId', 
          response.data.staffSettings.geoRegionId === null ? 1 : response.data.staffSettings.geoRegionId
        );
        
        localStorage.setItem(
          'staffMemberInfo',
          JSON.stringify(response.data.staffMemberInfo),
        );
        localStorage.setItem(
          'staffMemberSettings',
          JSON.stringify(response.data.staffSettings),
        );        
        //Get Sys_Settings
        const options = {
          method: 'GET',
          url: `/setting`,
        };
        axios
          .request(options)
          .then((response) => {
            localStorage.setItem(
              'sys_settings',
              JSON.stringify(response.data),
            );

            //Reload page, Routing will handle the redirect
            window.location.reload();
          })
          .catch((error) => {});
      })
      .catch((error) => {
        setIsLoading(false);
        if (error?.response?.status === 401) {
          //Wrong Username/Password
          toast.error(`Invalid Username / Password.`, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: false,
            progress: undefined,
          });
        } else {
          toast.error(
            `Internal Server Error, please contact support.`,
            {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              draggable: false,
              progress: undefined,
            },
          );
        }
      });
  };

  if (isLoading) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <Loader
            type="TailSpin"
            color="black"
            height="50"
            width="50"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row justify-content-center align-items-center padding-top-login ">
        <div className="form-label bold text-center">
          <h2 className="form-label font-weight-bold ">Welcome</h2>
          <p className="form-label bold">Sign in to continue</p>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-xl-12 card pt-4 pb-4">
          <div className="form-group">
            <div className="d-flex justify-content-center align-items-center border-bottom pb-3 mb-3">
              <img
                src={AppConstants.BASE_URL_FILE + 'AppShell/logo.png'}
                alt="Logo"
                style={{ width: '100%', margin: 0 }}
              />
            </div>
            <div className="mb-3">
              <label for="username" className="form-label">
                Username
              </label>
              <input
                autoComplete="on"
                name="username"
                className="form-control"
                placeholder="Username"
                onChange={handleChangeUsername}
              />
            </div>
            <div class="mb-3">
              <label for="Password" class="form-label">
                Password
              </label>
              <input
                autoComplete="on"
                type="password"
                name="Password"
                className="form-control"
                id="Password"
                onChange={handleChangePassword}
                placeholder="Please Enter your Password"
              />
            </div>
            <div class="mb-3 text-center">
              <button
                type="Sign in"
                className="btn btn-primary "
                onClick={() => signIn()}
              >
                Sign In
              </button>{' '}
            </div>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <small className="text-muted">
              {AppConstants.BUILD_NUMBER}
            </small>
            <small className="text-muted">
              {AppConstants.BUILD_DATE}
            </small>
          </div>
        </div>
      </div>
      <div class="text-right">
        <a href={AppConstants.WEB_APP_URL + '?force'} class="text-primary">Web App</a>
      </div>
    </div>
  );
};
